
import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.number,
  positionName: PropTypes.string,
  i18nLabel: PropTypes.string,
  bookingPriority: PropTypes.number,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
})